// @flow
import React, { Component } from "react";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";

const styles = (theme: DictionaryType): DictionaryType => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.common.white
  },
  tabRoot: {
    borderLeft: "1px solid #bbbbbb",
    borderRight: "1px solid #bbbbbb",
    borderBottom: "1px solid #bbbbbb",
    marginRight: "10px",
    color: theme.palette.grey.main
  },
  tabRootSelected: {
    borderBottom: "none",
    color: theme.palette.primary.main
  },
  tabLabel: {
    textTransform: "capitalize",
    fontSize: "0.875rem",
    color: "inherit",
    fontWeight: "500",
    "&:hover": {
      color: theme.palette.primary.light
    }
  },
  labelContainer: {
    paddingLeft: "12px",
    paddingRight: "12px",
    textAlign: "center"
  },
  indicator: {
    display: "none"
  }
});

type StyledTabsClassesType = {
  root: DictionaryType,
  tabRoot: DictionaryType,
  tabRootSelected: DictionaryType,
  tabLabel: DictionaryType,
  labelContainer: DictionaryType,
  indicator: DictionaryType
};

type TabType = {
  label: string,
  component?: React$Element<*>,
  to?: string
};

type StyledTabsStatesType = {
  value: number
};

type StyledTabsPropsType = {
  classes: StyledTabsClassesType,
  tabs: Array<TabType>,
  router?: string,
  linkComponent?: React$Element<*>
};

class StyledTabs extends Component<StyledTabsPropsType, StyledTabsStatesType> {
  constructor(props: StyledTabsPropsType) {
    super(props);
    this.state = {
      value: 0
    };
  }

  componentDidMount() {
    const router = this.props.router;
    if (router) {
      this.props.tabs.map(
        (tab: TabType, i: number): * => {
          if (router === tab.to) {
            this.setState({ value: i });
          }
        }
      );
    }
  }

  handleChange = (event: Event, value: number) => {
    this.setState({ value: value });
  };

  render(): React$Element<*> {
    const classes = this.props.classes;
    const value = this.state.value;
    const tabs = this.props.tabs.map(
      (tab: TabType, i: number): React$Element<*> => {
        if (tab.to) {
          return (
            <Tab
              key={"tab" + i}
              label={tab.label}
              classes={{
                root: classes.tabRoot,
                selected: classes.tabRootSelected,
                label: classes.tabLabel,
                labelContainer: classes.labelContainer
              }}
              component={this.props.linkComponent}
              to={tab.to}
            />
          );
        } else {
          return (
            <Tab
              key={"tab" + i}
              label={tab.label}
              classes={{
                root: classes.tabRoot,
                selected: classes.tabRootSelected,
                label: classes.tabLabel,
                labelContainer: classes.labelContainer
              }}
            />
          );
        }
      }
    );
    let container = null;
    if (this.props.tabs.length > 0 && this.props.tabs[value].component) {
      container = this.props.tabs[value].component;
    }
    return (
      <div className={classes.root}>
        <Tabs
          value={value}
          onChange={this.handleChange}
          classes={{ indicator: classes.indicator }}
          variant="scrollable"
          scrollButtons="off"
        >
          {tabs}
        </Tabs>
        {container}
      </div>
    );
  }
}

export default withStyles(styles)(StyledTabs);
